import { Col, DatePicker, Form } from "antd";
import { useEffect, useState } from "react";
import { getCommunicationAvailability } from "../../../Redux/OffersSlice";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { Wrapper } from "../../Deals/WeekPicker/pickerCss";
import updateLocale from "dayjs/plugin/updateLocale";


dayjs.extend(updateLocale);
dayjs.updateLocale("en", {
    weekStart: 1,
});

// A communication can never be scheduled mid-week, so "this week" is never
// selectable.
// - Mon/Tue/Wed: there's still enough lead time to schedule next week.
// - Thu/Fri/Sat/Sun: next week is too soon; the earliest selectable week
//   becomes the week after next.
const getEarliestSelectableWeekStart = () => {
    const dayOfWeek = dayjs().day(); // Sun=0, Mon=1, ... Sat=6
    const weeksAhead = dayOfWeek >= 1 && dayOfWeek <= 3 ? 1 : 2;
    return dayjs().add(weeksAhead, "week").startOf("week");
};

const CustomDatePicker = (props) => {
    const dispatch = useDispatch();

    const [disabledDates, setDisabledDates] = useState([]);
    const [targetWeekNumber, setTargetWeekNumber] = useState([])

    // Weekly scheduling locks in every Wednesday: Mon-Wed, next week is still
    // open to select; Thu-Sun, next week is locked and the week after next
    // becomes the earliest selectable week.
    const dayOfWeek = dayjs().day(); // 0=Sun ... 6=Sat
    const weeksUntilSelectable = (dayOfWeek >= 1 && dayOfWeek <= 3) ? 1 : 2;
    const nextWeek = dayjs().add(weeksUntilSelectable, 'week').valueOf();

    let { communicatoinAvailability } = useSelector((state) => state?.offers) || [];

    useEffect(() => {
        if (props.restaurantId) {
            getCommunicationAvailabilityAPI(dayjs().format('MM'), dayjs().format('YYYY'), props.restaurantId)
        }
    }, [props.restaurantId])

    const getCommunicationAvailabilityAPI = (currentMonth, currentYear, restaurantId) => {
        if (restaurantId) {
            dispatch(getCommunicationAvailability({ currentMonth, currentYear, restaurantId }))
        }
    }
    useEffect(() => {
        if (communicatoinAvailability && communicatoinAvailability.length > 0) {
            setDisabledDates(Array.from(new Set(communicatoinAvailability?.map(i =>
                i.toDate
            )?.flat())))
        } else {
            setDisabledDates([])
        }
    }, [communicatoinAvailability])



    const disabledDate = (current) => {

        // Disable past dates from the current date (Only for staging and dev server for testing purpose)
        if (current.isBefore(dayjs(), 'day')) {
            return true;
        }

        //Disabled for weeks that already have a scheduled communication
        if (disabledDates.find(i => dayjs(i).week() === current.week())) {
            return true;
        }

        //Disable any week before the earliest selectable week (current week, and next week once locked in)
        if (current.isBefore(dayjs(nextWeek), 'week')) {
            return true;
        }

        return false;
    };

    const dateRender = (current) => {
        const isDisabled = disabledDates.find(i => dayjs(i).week() === current.week());

        if (isDisabled) {
            return (
                <div style={{ display: "inline-block" }}>
                    {current.date()}
                    <div className="errortolltip">
                        <p>
                            This Date cannot be selected because it is outside of the review
                            period, please select a date further away. Unavailable dates are
                            shown with a gray background.
                        </p>
                    </div>
                </div>
            );
        }

        return <div className="ant-picker-cell-inner">{current.date()}</div>
    };
    return (
        <>
            <Col  {...props.col}>
                <Wrapper>

                    <Form.Item
                        name={props.name}
                        label={props.label}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        initialValue={props.value}
                        className="form-group"
                        rules={props.rules}
                    >
                        <DatePicker
                            dateRender={dateRender}
                            disabledDate={disabledDate}
                            value={props.value}
                            format={props.format}
                            name={props.name}
                            getPopupContainer={triggerNode => triggerNode.parentNode}
                            onChange={props.onChange}
                            allowClear={false}
                            placeholder={props.placeholder}
                            onPanelChange={(value, mode) => {
                                getCommunicationAvailabilityAPI(value.format('MM'), value.format('YYYY'), props.restaurantId)
                            }}
                            // disabledDate={(current) => {
                            //     let customDate = moment().format(props.format);
                            //     return current && current < moment(customDate, props.format);
                            // }}
                            onWheel={props.onWheel}
                            disabled={props.disabled}
                        />
                    </Form.Item>
                </Wrapper>
            </Col>
        </>
    )
}
export default CustomDatePicker;